export default function groupByType(collection, type) {
  return collection.reduce((acc, item) => {
    const key = item[type]
    if (!acc[key]) {
      acc[key] = []
    }
    acc[key].push(item)
    return acc
  }, {})
}
